import classNames from "classnames";
import React from "react";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import QuestionHeader from "./QuestionHeader";
import { RequiredDocAnswerableQuestionProps } from "./RequiredDocAnswerableQuestion";
import RequiredDocReadonlyAnswer from "./RequiredDocReadonlyAnswer";
import { scrollToViewAfterKeyboardOpen } from "./ScheduledVisitDocScreenUtils";

type Props = RequiredDocAnswerableQuestionProps;

const RequiredDocNumber = (props: Props) => {
  return (
    <AppCard
      className={classNames({ __invalid: !props.isValid })}
      onClick={(e) => {
        if (props.readonly && props.onClickWhileDisabled !== undefined) {
          props.onClickWhileDisabled();
        } else {
          scrollToViewAfterKeyboardOpen(e);
        }
      }}
    >
      <QuestionHeader
        text={props.questionText}
        isRequired={props.isRequired}
        notes={props.notes}
        isReadonly={props.readonly}
      />
      <AppCardContent>
        {props.readonly ? (
          <RequiredDocReadonlyAnswer currentAnswer={props.currentAnswer} />
        ) : (
          <input
            type="number"
            pattern="\\d*"
            disabled={props.readonly}
            className="ScheduledVisitDocScreen__margin ScheduledVisitDocScreen__block text-input text-input--material"
            onChange={(event: any) => {
              props.handleOnInsertAnswer(props.questionId, event.target.value);
            }}
            value={props.currentAnswer === null ? "" : props.currentAnswer}
          />
        )}
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(RequiredDocNumber);
